import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import sankeyTreeLayout from './sankeyTreeLayout';
import SankeyTreeView from './SankeyTreeView';

/**
 * 桑基图注册
 */
export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerLayout(sankeyTreeLayout);
  registers.registerChartView(SankeyTreeView);
}
